__turbopack_context__.v({
  "close-button": "TextBlockEditorToolbar-module-scss-module__lDUSZq__close-button",
  "font-content-wrapper": "TextBlockEditorToolbar-module-scss-module__lDUSZq__font-content-wrapper",
  "font-option-container": "TextBlockEditorToolbar-module-scss-module__lDUSZq__font-option-container",
  "font-size": "TextBlockEditorToolbar-module-scss-module__lDUSZq__font-size",
  "spacer": "TextBlockEditorToolbar-module-scss-module__lDUSZq__spacer",
  "toolbar": "TextBlockEditorToolbar-module-scss-module__lDUSZq__toolbar",
  "toolbar-item": "TextBlockEditorToolbar-module-scss-module__lDUSZq__toolbar-item",
});
